import { render, staticRenderFns } from "./blog-archive-year.vue?vue&type=template&id=5bb8c74f&"
import script from "./blog-archive-year.vue?vue&type=script&lang=js&"
export * from "./blog-archive-year.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports